import {connect} from 'react-redux';
import {Notebook} from '@learningblocks/storybook-components';
import {
  getDesignChapterOptions,
  getViewTypeForStepOptions,
} from './DesignChapterContentBlock.selector';
import {viewThreeSetStep, viewFourSetStep} from '@learningblocks/exp-redux';

function mapStateToProps(state, ownProps) {
  return {
    options: getDesignChapterOptions(state),
    viewType: getViewTypeForStepOptions(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetStepViewThree: (params) => dispatch(viewThreeSetStep(params)),
    onSetStepViewFour: (params) => dispatch(viewFourSetStep(params)),
  };
}

export const DesignChapterContentBlock = connect(
  mapStateToProps,
  mapDispatchToProps
)(Notebook.DesignChapterContentBlock);
